export default __webpack_public_path__ + "static/media/SkillsGuildPoster.e2637f29.png";